import React from 'react';
import { Doctor } from 'types/doctor';
import DoctorItemModule from './DoctorItemModule';
import List from 'components/list/List';

type DoctorListModuleProps = {
  doctors: Doctor[];
};

const DoctorListModule: React.FC<DoctorListModuleProps> = ({ doctors }) => {
  return (
    <List>
      {doctors.map(doctor => (
        <DoctorItemModule key={doctor.id} doctor={doctor} />
      ))}
    </List>
  );
};

export default DoctorListModule;
